import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getKakaoTalkSettings = ({
  kakaoTalkId
}: Partial<ChatsChannelBase>) => {
  if (!kakaoTalkId) return null;

  const url = `https://pf.kakao.com/${kakaoTalkId}/chat`;

  return {
    provider: ChatsChannelType.kakaotalk,
    link: { url },
    title: 'KakaoTalk',
    icon: getChatIcon(ChatsChannelType.kakaotalk),
    color: 'rgb(255, 235, 59)'
  } as ChatsChannelSetting;
};
